import {
  ComponentType,
  DataType,
  Layout,
} from '@vgtv/api-client/lib/component';

import { COMPONENT_TYPE_GALLERY } from '../../../consts';
import { getStyleProperty } from '../../../utils/getStyleProperty';

import type { ExtendedComponentType } from '../getComponentDataFetchLimit';
import type { ImageSize } from '../../../helpers/images';

/**
 * Returns the number of visible items (in viewport for sliders, in a row for lists) for a component (the values are read from CSS custom properties).
 */
const getComponentItemsCount = function ({
  componentType,
  dataType,
  componentLayout,
  size = 'medium',
}: {
  componentType: ExtendedComponentType;
  dataType: DataType;
  componentLayout?: Layout;
  size?: ImageSize;
}): number | undefined {
  if (
    (componentType === ComponentType.SLIDER &&
      dataType === DataType.ASSETS &&
      componentLayout === Layout.VERTICAL) ||
    (componentType === ComponentType.SLIDER && dataType === DataType.STORIES)
  ) {
    return parseFloat(getStyleProperty('--slider-assets-vertical-count'));
  }

  if (
    (componentType === ComponentType.SLIDER ||
      componentType === ComponentType.CONTINUE_WATCHING) &&
    (dataType === DataType.ASSETS || dataType === DataType.CATEGORIES)
  ) {
    if (size === 'large') {
      return parseFloat(getStyleProperty('--large-slider-elements-count'));
    }

    return parseFloat(getStyleProperty('--slider-elements-count'));
  }

  if (
    componentType === ComponentType.SLIDER &&
    dataType === DataType.PROFILES
  ) {
    return parseFloat(getStyleProperty('--slider-profiles-count'));
  }

  if (
    componentType === ComponentType.EDITORIAL &&
    dataType === DataType.ASSETS &&
    componentLayout === Layout.VERTICAL
  ) {
    return parseFloat(getStyleProperty('--slider-editorial-vertical-count'));
  }

  if (
    componentType === ComponentType.EDITORIAL &&
    dataType === DataType.ASSETS
  ) {
    return parseFloat(getStyleProperty('--slider-editorial-count'));
  }

  if (
    componentType === ComponentType.LIST &&
    dataType === DataType.ASSETS &&
    componentLayout === Layout.VERTICAL
  ) {
    return parseFloat(getStyleProperty('--list-assets-vertical-count'));
  }

  if (
    componentType === ComponentType.LIST &&
    dataType === DataType.ASSETS &&
    componentLayout === Layout.HORIZONTAL
  ) {
    return parseFloat(getStyleProperty('--list-assets-horizontal-count'));
  }

  if (
    componentType === ComponentType.LIST &&
    dataType === DataType.CATEGORIES
  ) {
    return parseFloat(getStyleProperty('--list-categories-count'));
  }

  if (
    componentType === ComponentType.FILTERED_LIST &&
    dataType === DataType.ASSETS &&
    componentLayout === Layout.HORIZONTAL
  ) {
    return parseFloat(getStyleProperty('--filtered-list-assets-count'));
  }

  if (
    componentType === ComponentType.FILTERED_LIST &&
    dataType === DataType.ASSETS &&
    componentLayout === Layout.VERTICAL
  ) {
    return parseFloat(
      getStyleProperty('--filtered-list-assets-vertical-count')
    );
  }

  if (componentType === COMPONENT_TYPE_GALLERY) {
    return parseFloat(getStyleProperty('--assets-gallery-count'));
  }
};

export { getComponentItemsCount };
